import { QueueManagementConstants } from '../../../../queueManagement/QueueManagementConstants';
import { ToastType } from 'modules/application/misc/ToastService';
import { ReasonCodes } from 'types/ReasonCodes';
export class TagsQueueService {
    static $inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', '$translate', 'BlipToastService'];
    constructor(MessagingHubService, MESSAGINGHUBDOMAIN, $translate, BlipToastService) {
        'ngInject';
        this.MessagingHubService = MessagingHubService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
        this.$translate = $translate;
        this.BlipToastService = BlipToastService;
    }
    /**
     * Add or update and tags to an Queue
     * @param application
     * @param tagsQueue
     */
    async set(application, tagsQueue, queueId) {
        const resource = {
            ownerIdentity: `${application.shortName}@${this.MESSAGINGHUBDOMAIN}`,
            tag: tagsQueue,
            AttendanceQueueId: queueId,
        };
        try {
            const tagsQueueAttendance = await this.MessagingHubService.sendCommand({
                method: 'set',
                to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
                type: 'application/vnd.iris.desk.attendancequeuetag+json',
                uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}/${encodeURIComponent(queueId)}/tags`,
                resource: resource,
            });
            return tagsQueueAttendance;
        }
        catch (error) {
            this.showToast('queue-management.errors.cannotAddTagsQueueAttendance', ToastType.Danger);
        }
    }
    /**
     * Delete an Tags for this queue
     * @param idTagsQueue
     * @param queueId
     */
    async delete(tagsQueueAttendance, queueId) {
        await tagsQueueAttendance.forEach(tags => {
            try {
                this.MessagingHubService.sendCommand({
                    method: 'delete',
                    to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
                    uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}/${encodeURIComponent(queueId)}/tags/${encodeURIComponent(tags.id)}`,
                });
            }
            catch (e) {
                this.showToast('queue-management.errors.cannotRemoveTagsQueueAttendance', ToastType.Danger);
            }
        });
    }
    /**
     * Get Tags for this Id queue
     * @param queueId - the queue's ID
     */
    async getTagsQueue(queueId) {
        try {
            const { items } = await this.MessagingHubService.sendCommand({
                method: 'get',
                to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
                uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}/${encodeURIComponent(queueId)}/tags`,
            });
            const tagsQueue = items.map((tag) => {
                return {
                    id: tag?.id,
                    tag: tag.tag,
                    ownerIdentity: tag?.ownerIdentity,
                    attendanceQueueId: tag?.attendanceQueueId,
                };
            });
            return tagsQueue;
        }
        catch (e) {
            if (e.code != ReasonCodes.ResourceNotFound) {
                this.showToast('queue-management.errors.cannotLoadTagsQueueAttendance', ToastType.Danger);
                return [];
            }
        }
    }
    /**
     * Get Tags for this name queue
     * @param queueName - the queue's Name
     */
    async getTagsQueueName(queueName) {
        try {
            const { items } = await this.MessagingHubService.sendCommand({
                method: 'get',
                to: `${QueueManagementConstants.DESTINATION.DESK}${this.MESSAGINGHUBDOMAIN}`,
                uri: `${QueueManagementConstants.URL.ATTENDANCE_QUEUES}/name/${encodeURIComponent(queueName)}/tags`,
            });
            const tagsQueue = items.map((tag) => {
                return {
                    id: tag?.id,
                    tag: tag.tag,
                    ownerIdentity: tag?.ownerIdentity,
                    attendanceQueueId: tag?.attendanceQueueId,
                };
            });
            return tagsQueue;
        }
        catch (e) {
            if (e.code != ReasonCodes.ResourceNotFound) {
                this.showToast('queue-management.errors.cannotLoadTagsQueueAttendance', ToastType.Danger);
            }
            return [];
        }
    }
    async showToast(messageReference, type) {
        const msg = await this.$translate(messageReference);
        const toastOptions = { msg };
        await this.BlipToastService.show(type, toastOptions);
    }
}
TagsQueueService.$inject = ['MessagingHubService', 'MESSAGINGHUBDOMAIN', '$translate', 'BlipToastService'];
